import React, { Suspense } from 'react';
import bem from 'utils/bem';
import { useMobile } from 'utils/media';
import { observer } from 'mobx-react-lite';
import Text from 'components/Text';
import Slider from 'components/Slider';
import SocialIcons from 'components/SocialIcon/SocialIcons';
import YouTubeTeaser, { YouTubeSkeletonTeaser } from 'components/YouTubeTeaser';
import Model from '../../../model';
import { times } from 'utils/render';
import './index.sass';
import { IconButton } from 'components/Button';
import { ShowMore } from 'components/ShowMore';

const { block, el } = bem('mediatek');

const Mediatek = ({ title, description }) => {
    const { isMobile } = useMobile();
    const Fallback =<div className={ el('teasers') }>{ times((key) => <YouTubeSkeletonTeaser key={key} />, 2) }</div>
    return (
        <div className={ block() }>
            <div className={ el('top-block') }>
                <div className={ el('title') }><Text serif>{ title }</Text></div>
                { description && <div className={ el('description') }>
                    <Text>{ description }</Text>
                </div> }
            </div>
            <div className={ el('slider') }>
                <Suspense fallback={Fallback}>
                    <VideoBlock isMobile={isMobile} />
                </Suspense>
            </div>
            <div className={ el('more') }>
                <Text serif>Подкасты проекта можно послушать на следующих площадках</Text>
                <div className={ el('podcasts')}>
                    <IconButton name={'google-podcasts-logo'} target='_blank' to={'https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkcy5zb3VuZGNsb3VkLmNvbS91c2Vycy9zb3VuZGNsb3VkOnVzZXJzOjczMDQ5Njg1Ny9zb3VuZHMucnNz'} />
                    <IconButton name={'yandex-music-icon'} target='_blank' to={'https://music.yandex.ru/album/10122551'} />
                    <IconButton name={'apple-podcasts-big'} target='_blank' to={'https://podcasts.apple.com/ru/podcast/otvet-co/id1488897817'} />
                </div>
            </div>
        </div>
    );
};

const VideoBlock = observer(({isMobile}) => {
    const { specialistsData, videos } = Model.specialist;
    specialistsData.read();
    const teasers = videos.map((video, index) => {
        return <YouTubeTeaser key={index} link={ video }/>;
    });
    return isMobile ?
        <div className={ el('teasers') }>
            <ShowMore step={2}>{ teasers }</ShowMore>
        </div> :
        <Slider items={ teasers } number={ 2 }/>
})

export default observer(Mediatek);

